import { Gallery } from "../gallery/gallery";
import "./about.css";

export const About = () => {
  return (
    <div className="about-page">
      <section className="about-section">
        <div className="about-top">
          <h1>What About us</h1>
          <p>
            Experience luxury, comfort, and culinary excellence under one roof.
          </p>
        </div>
        <main>
          <p>
            Nestled in the heart of the city, our hotel offers world-class
            accommodations and a warm, welcoming atmosphere. Our restaurant
            serves gourmet cuisine prepared by top chefs, using only the finest
            ingredients to delight your taste buds.
          </p>
          <small>
            Whether you're here for a business trip, a family vacation, or a
            romantic getaway, we ensure that your stay is unforgettable.
          </small>
        </main>
        <Gallery />
      </section>
    </div>
  );
};
